export interface ReportsSummaryApiResource {
  date_from: string;
  date_to: string;
  total_visits: number;
  completed_visits: number;
  cancelled_visits: number;
  active_clients: number;
  summaries_shared: number;
}

export interface ReportsSummary {
  dateFrom: string;
  dateTo: string;
  totalVisits: number;
  completedVisits: number;
  cancelledVisits: number;
  activeClients: number;
  summariesShared: number;
}

export function mapApiResourceToReportsSummary(resource: ReportsSummaryApiResource): ReportsSummary {
  return {
    dateFrom: resource.date_from,
    dateTo: resource.date_to,
    totalVisits: resource.total_visits,
    completedVisits: resource.completed_visits,
    cancelledVisits: resource.cancelled_visits,
    activeClients: resource.active_clients,
    summariesShared: resource.summaries_shared,
  };
}

export interface VisitsByTypeRowApiResource {
  period: string;
  therapy_type: string;
  count: number;
}

export interface VisitsByTypeRow {
  period: string;
  therapyType: string;
  count: number;
}

export function mapApiResourceToVisitsByTypeRow(
  resource: VisitsByTypeRowApiResource
): VisitsByTypeRow {
  return { period: resource.period, therapyType: resource.therapy_type, count: resource.count };
}

export interface VisitsByStatusRowApiResource {
  status: string;
  count: number;
}

export interface VisitsByStatusRow {
  status: string;
  count: number;
}

export function mapApiResourceToVisitsByStatusRow(
  resource: VisitsByStatusRowApiResource
): VisitsByStatusRow {
  return { status: resource.status, count: resource.count };
}

export interface TreatmentsDeliveredRowApiResource {
  treatment_id: string;
  treatment_name: string;
  count: number;
}

export interface TreatmentsDeliveredRow {
  treatmentId: string;
  treatmentName: string;
  count: number;
}

export function mapApiResourceToTreatmentsDeliveredRow(
  resource: TreatmentsDeliveredRowApiResource
): TreatmentsDeliveredRow {
  return {
    treatmentId: resource.treatment_id,
    treatmentName: resource.treatment_name,
    count: resource.count,
  };
}
